// extracted by mini-css-extract-plugin
var _1 = "EmailTableRowActivities-modulelist__E5CwE";
export { _1 as "list" }
